/**
 * View Support Inbox manifest — `view-support-inbox` action.
 *
 * Low-prominence employee triage: open a company's live Google support-group
 * inbox (the "Support Inbox" tab on the company detail page) to look at inbound
 * support mail before a ticket exists.
 *
 * The primary entity is the company. The cross-entity resolver walks to the
 * owning company from a contact (contact → company) or a ticket
 * (ticket → contact → company), so the action appears in those entities'
 * right-click / overflow menus too. `mode: "client-redirect"` with no extra
 * inputs → the resolver auto-advances single-candidate hops and skips the
 * confirm step, then `clientRun` navigates to the resolved company's tab.
 *
 * On the company itself, `executeDetailAction`'s same-entity bypass skips the
 * resolver and runs the `viewSupportInbox` handler directly (a plain navigate
 * to `?tab=support-inbox`). The tab renders its own enrolled / not-enrolled
 * empty state, so navigating is always safe even without an enrolled group.
 */

import { registerActionManifest } from "./registry";

registerActionManifest({
  actionId: "view-support-inbox",
  label: "Support inbox",
  primaryEntity: "company",
  requires: {
    entity: "company",
    requiredFields: [],
  },
  mode: "client-redirect",
  clientRun: (resolved, hooks) => {
    const companyId = resolved.targetIds[0];
    if (!companyId) {
      hooks.onToast(
        "No linked company to open a support inbox for.",
        "warning",
      );
      return;
    }
    hooks.onNavigate(`/companies/${companyId}?tab=support-inbox`);
  },
});
